<template>
  <div class="full">
    <BGTemplate class="cg-layer full" bloom="bubbles" @ready="(v) => { engine = v; }">
    </BGTemplate>
    <BlueBubbles v-if="engine && engine.renderer && engine.scene && engine.camera" :camera="engine.camera" :amount="20" :renderer="engine.renderer" :scene="engine.scene"></BlueBubbles>

    <div class="cg-layer scroller">
      <Toolbar></Toolbar>

      <div ref="toucher">

        <div class="admin lobby">

          <div class="lobby-wrapper">
          <h1 class="centertext pad-30">
            Instructor's Dashboard
          </h1>
            <!-- <div> -->
              <!-- <img class="click back-icon" src="../img/back.svg" @click="$router.push('/cloud/choose-role')" alt=""> -->
              <!-- <img class="click" src="../img/logout.svg" @click="logout()" alt=""> -->
            <!-- </div> -->

          <div class="grey-area">
            <div class="tab-row">
              <div class="tab-icon " :class="{ active: viewing === 'mygames' }" @click="viewing = 'mygames'">My Games</div>
              <div class="tab-icon "  :class="{ active: viewing === 'creategame' }"  @click="viewing = 'creategame'">Create Game</div>
            </div>
            <!-- MYGAMES -->
            <div class="tab-box" v-if="viewing === 'mygames'">
              <MyGames ref="mygamescompo"></MyGames>
            </div>
            <!-- Crate Room -->
            <div class="tab-box" v-if="viewing === 'creategame'">
              <div class="box-create-room">
                <CreateGame @ok="() => { viewing = 'mygames'; onReload() }"></CreateGame>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div style="height: 150px;"></div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  components: {
    Toolbar: () => import(/* webpackChunkName: "cloud" */ '../ui/Toolbar.vue'),
    BlueBubbles: () => import(/* webpackChunkName: "cloud" */ '../game/BlueBubbles.vue'),
    BGTemplate: () => import(/* webpackChunkName: "cloud" */ '../game/BGTemplate.vue'),
    // GameLobby: () => import('../../../_cloud/v0-general/ui/GameLobby.vue'),
    CreateGame: () => import('../../../_cloud/v0-general/ui/CreateGame.vue'),
    MyGames: () => import('../../../_cloud/v0-general/ui/MyGames.vue')
  },
  data () {
    return {
      newRoom: false,
      mode: '',
      viewing: 'mygames', // mygames, mygames
      engine: false
    }
  },
  methods: {
    onReload () {
      let compo = this.$refs['mygamescompo']
      if (compo) {
        compo.$emit('reload')
      }
    }
  }
}
</script>

<style scoped>
.full-w {
  width: 100%;
}
.suggestions {
  color: black;
}
.lobby {
  font-size: 20px;
  color: white;

  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.lobby-wrapper {
  /* padding: 0px 30px; */
  max-width: calc(800px - 10px * 2.0);
  margin: 0px auto;
}
.lobby-title {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 30px;
}

.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: red; */
}
.admin{
  color: white;
}

.action{
  font-size: 20px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  text-decoration: underline
}

.room-item{
  border: white solid 3px;
  margin: 20px;
  padding: 10px;
}
.room-list .action{
  margin-left: 10px;
}

.newtext{
  font-size: 20px;
  background-color: transparent;
  color: white;
  border: none;
  border-bottom: white solid 3px;
  height: 70px;
}

.flex-row{
  display: flex;
  /* justify-content: space-around; */
}
.flex-row > div{
  margin: 10px;
}

.tab-button{
  border: white solid 1px;
  padding: 10px 20px;
  margin: 10px;
  font-size: 30px;
  display: inline-block;
  cursor: pointer;
}

.border-top{
  margin-top: 50px;
  border-top: white solid 3px;
}
.grey-area{
  border-radius: 34px;
  padding: 0px;
  color: black;
  width: 100%;
  background-color: #E5E0E0;
  overflow: hidden;
  max-width: calc(800px - 20px * 2);
}
.tab-row{
  padding: 20px;
  padding-bottom: 0px;
  width: calc(100% - 20px * 2);
  display: flex;
}
.tab-box{
  padding: 20px;
  padding-bottom: 30px;
  width: calc(100% - 20px * 2);
  background-color: white;
}
.tab-icon{
  opacity: 0.4;
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 15px 15px 0px 0px;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 15px;
}

.active.tab-icon{
  opacity: 1.0;
}

.analytics{
  color: #4195F7;
}

.mygame-block{
  width: calc(100% - 10px * 2);
  padding: 10px;
  box-shadow: 0px 0px 30px 0px #bdbdbd;
  background-color: white;
  margin: 10px 0px 30px 0px;
  border-radius: 10px;
}
.mygame-block:last-child{
  margin-bottom: 0px;
}

.game-title{
  height: 30px;
  width: 100%;
  max-width: 300px;
  appearance: none;
  outline: none;
  box-shadow: none;
  border: none;
  border-radius: 0px;
  border-bottom: black solid 1px;
  font-size: 25px;
  resize: none;
  padding: 10px 0px;
}
.box-title-row{
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: calc(100% - 10px * 2);
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.box-title-name{
  display: flex;
}
.box-title-analytics{
  margin-top: 20px;
}

@media screen and (min-width: 767px) {
  .box-title-row{
    flex-direction: row;
  }
  .box-title-analytics{
    margin-top: 0px;
  }
}

.info-block{
  background-color: antiquewhite;
  margin: -10px;
  padding: 10px 20px;
  font-size: 13px;
  border-radius: 0px 0px 8px 8px;
  margin-top: 10px;
}
.box-create-room{
  max-width: 350px;
  margin: 0px auto;
}

.text-input{
  appearance: none;
  box-shadow: none;
  border: #ccc solid 1px;
  border-radius: 10px;
  outline: none;
  padding: 10px;
  margin: 10px;
  margin-left: 0px;
  background-color: #F0EFEF;
}

.vly-center{
  display: flex;
  align-items: center;
}
.m-left{
  margin-left: 10px;
}

.text-input.primary{
  color: rgb(255, 255, 255);
  background-color: #4195F7;
}

.header-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vh-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.back-icon{
  width: 48px;
  margin-right: 20px;
}

.text-input.roompw{
  margin-left: 10px;
}
</style>
